<template>
  <div class="detail">
    <div class="img-con" @click="showBanner(bannerList, 0)">
      <swiper v-if="bannerList && bannerList.length" :list="bannerList" />
      <div
        :class="[
          'top-icon',
          detail.status == 1
            ? 'bg-1'
            : detail.status == 2
            ? 'bg-2'
            : detail.status == 3
            ? 'bg-3'
            : 'bg-4',
        ]"
      ></div>
    </div>
    <!-- status 1:处理中 2:已反馈 3.不合格 4.已完成 -->
    <div class="line">基础描述</div>
    <div class="foot">
      <div class="item">
        <div class="v1">督查点位：</div>
        <div class="v1">
          {{ detail.point_name }}
        </div>
      </div>
      <div class="item">
        <div class="v1">考察内容：</div>
        <div class="v1">
          {{ detail.cate_name }}
        </div>
      </div>
      <div class="item">
        <div class="v1">详细地址：</div>
        <div class="address">
          {{ detail.address }}
        </div>
      </div>
      <div class="item">
        <div class="v1">责任部门：</div>
        <div class="v1">
          {{ detail.area_name }}
        </div>
      </div>
      <div class="item">
        <div>接单时间：</div>
        <div>
          {{ detail.add_time_text }}
        </div>
      </div>
      <div class="item">
        <div class="v1">整改期限：</div>
        <div class="v1">
          {{ detail.expire_time_text }}
        </div>
      </div>
      <!-- <div class="item">
        <div class="v1">督查员：</div>
        <div class="address">
          {{ detail.realname }}
        </div>
      </div>
      <div class="item">
        <div class="v1">督查员号码：</div>
        <div class="address">
          {{ detail.mobile }}
        </div>
      </div> -->
      <div class="item-content">
        <div class="v1">事件描述：</div>
        <div class="desc-text">
          {{ detail.content }}
        </div>
      </div>
    </div>
    <!-- <div class="line">事件描述</div> -->
    <div class="body" v-if="detail.finish_time_text">
      <!-- <div class="item">
        <div>接单人：</div>
        <div>
          {{ detail.name }}
        </div>
      </div>
      <div class="item">
        <div>联系电话：</div>
        <div>
          {{ detail.name }}
        </div>
      </div> -->
      <div class="item" v-if="detail.finish_time_text">
        <div>完成时间：</div>
        <div>
          {{ detail.finish_time_text }}
        </div>
      </div>
      <div class="item-content" v-if="detail.chargeback_reason">
        <div>退单理由：</div>
        <div>
          <textarea v-model="detail.chargeback_reason" readonly></textarea>
        </div>
      </div>
      <div class="item-content" v-if="detail.rejection_reason">
        <div>拒退理由：</div>
        <div>
          <textarea v-model="detail.rejection_reason" readonly></textarea>
        </div>
      </div>
      <div class="item-content-el" v-if="detail.processing_describe_1">
        <div class="v1">第一次处理描述：</div>
        <div class="v2">
          <textarea v-model="detail.processing_describe_1" readonly></textarea>
        </div>
        <img
          style="width: 1.44rem; height: 1.44rem; margin-top: 0.14rem"
          :src="$IMG_PATH + item"
          alt=""
          @click="showImg(detail.feedback_img_1, index)"
          v-for="(item, index) in detail.feedback_img_1"
          :key="index"
        />
      </div>

      <div class="item-content" v-if="detail.unqualified_reason_1">
        <div>一次不合格理由：</div>
        <div>
          <textarea v-model="detail.unqualified_reason_1" readonly></textarea>
        </div>
      </div>

      <div class="item-content-el" v-if="detail.processing_describe_2">
        <div class="v1">第二次处理描述：</div>
        <div class="v2">
          <textarea v-model="detail.processing_describe_2" readonly></textarea>
        </div>
        <img
          style="width: 1.44rem; height: 1.44rem; margin-top: 0.14rem"
          :src="$IMG_PATH + item"
          alt=""
          @click="showImg(detail.feedback_img_2, index)"
          v-for="(item, index) in detail.feedback_img_2"
          :key="index"
        />
      </div>
      <div class="item-content" v-if="detail.unqualified_reason_2">
        <div>二次不合格理由：</div>
        <div>
          <textarea v-model="detail.unqualified_reason_2" readonly></textarea>
        </div>
      </div>
    </div>
    <div class="line" v-if="detail.finish_reason">完成描述</div>
    <div class="body" v-if="detail.finish_reason">
      <div class="item-content" v-if="detail.finish_reason">
        <div>结案理由：</div>
        <div>
          <textarea v-model="detail.finish_reason" readonly></textarea>
        </div>
      </div>
    </div>
    <div class="btns">
      <div
        class="v1"
        @click="showone = true"
        v-if="detail.status == 1 && detail.is_refuse == 0"
      >
        退单
      </div>
      <div class="v2" @click="showtwo = true" v-if="detail.status == 1">
        去处理
      </div>
    </div>
    <van-dialog
      v-model="showone"
      title="退单理由"
      show-cancel-button
      @confirm="subDel"
    >
      <van-field
        v-model="message1"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="showtwo"
      title="处理工单"
      show-cancel-button
      @confirm="subDeal"
    >
      <div class="diog">
        <div class="foot">
          <div class="item">
            <div class="v1">督查点位：</div>
            <div class="v1">
              {{ detail.point_name }}
            </div>
          </div>
          <div class="item">
            <div class="v1">考察内容：</div>
            <div class="v1">
              {{ detail.cate_name }}
            </div>
          </div>
          <div class="item">
            <div class="v1">地址：</div>
            <div class="address">
              {{ detail.address }}
            </div>
          </div>
          <div class="item">
            <div class="v1">接单时间：</div>
            <div class="v1">
              {{ detail.add_time_text }}
            </div>
          </div>
          <div class="item-content-m">
            <div class="v1">处理描述：</div>
            <div>
              <textarea
                v-model="message2"
                placeholder="请输入处理描述"
              ></textarea>
            </div>
          </div>
          <div class="item-content-m">
            <div class="v1">上传照片(现场拍照，最多三张)：</div>
            <upload :maxCount="3" v-model="imgList" />
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Swiper from "@/components/Swiper";
import upload from "@/components/Upload";
import { getMyEventDetail, changeWork } from "../api";
import { Dialog } from "vant";
import { Toast } from "vant";
import { ImagePreview } from "vant";
export default {
  components: {
    Swiper,
    [Dialog.Component.name]: Dialog.Component,
    upload,
  },
  data() {
    return {
      bannerList: [],
      showone: false,
      showtwo: false,
      message1: "",
      message2: "",
      imgList: [],
      detail: {},
    };
  },
  created() {
    let id = this.$route.params.id;
    this.init(id);
  },
  methods: {
    init(id) {
      let params = {
        id: id,
      };
      getMyEventDetail(params).then((res) => {
        console.log("res", res);
        this.detail = res.data;
        this.bannerList = this.detail.img.map((e) => {
          return this.$IMG_PATH + e;
        });
      });
    },
    showImg(imgList, index) {
      let imgs = [];
      imgList.forEach((item) => {
        imgs.push(this.$IMG_PATH + item);
      });
      this.instance_show = ImagePreview({
        images: imgs,
        startPosition: index,
      });
    },
    showBanner(imgList, index) {
      this.instance_show = ImagePreview({
        images: imgList,
        startPosition: index,
      });
    },
    subDeal() {
      if (!this.message2) {
        Toast.fail("请输入处理内容");
      } else if (this.imgList == 0) {
        Toast.fail("请至少上传一张图片");
      } else {
        let params = {
          type: 2,
          id: this.detail.id,
          content: this.message2,
          img: this.imgList,
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("处理成功");
            setTimeout(() => {
              this.$router.replace("/myEventOrder");
            }, 1200);
          }
        });
      }
    },
    subDel() {
      if (!this.message1) {
        Toast.fail("请输入退单理由");
      } else {
        let that = this;
        this.showone = false;
        Toast.loading("提交中");
        let params = {
          type: 1,
          id: this.detail.id,
          content: this.message1,
          token: window.localStorage.getItem("token"),
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("退单成功");
            setTimeout(() => {
              that.$router.replace("/myEventOrder");
            }, 1200);
          }
          this.message1 = "";
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0.24rem 0.3rem 0.54rem;
  overflow: hidden;
  .img-con {
    width: 100%;
    height: 3.9rem;
    overflow: hidden;
    margin-bottom: 0.24rem;
    position: relative;
    /deep/.swiper {
      width: 100%;
      height: 3.9rem !important;
      overflow: hidden;
    }
    /deep/ img {
      width: 100%;
      height: 3.9rem !important;
      display: block;
      border-radius: 0.08rem;
    }
    .top-icon {
      width: 1.4rem;
      height: 0.72rem;
      position: absolute;
      top: 8%;
      right: 0;
    }
    .bg-0 {
      background-image: url("../../../assets/images/mine/3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-1 {
      background-image: url("../../../assets/images/mine/6.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-2 {
      background-image: url("../../../assets/images/mine/7.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-3 {
      background-image: url("../../../assets/images/mine/8.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-4 {
      background-image: url("../../../assets/images/mine/9.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .body {
    width: 100%;
    min-height: 1rem;
    background-color: #fff;
    border-radius: 0.14rem;
    margin-top: 0.3rem;
    padding: 0 0.2rem 0.2rem;
    > div:last-child {
      border: none;
    }
    .item {
      height: 0.9rem;
      display: flex;
      line-height: 0.9rem;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 2rem;
      }
      > div:last-child {
        width: calc(100% - 2rem);
        color: #999;
      }
    }
    .item-content {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        min-height: 1.4rem;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: none;
        }
      }
    }
    .item-content-el {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      .v1 {
        min-width: 2rem;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      .v2 {
        width: 100%;
        min-height: 1.4rem;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: none;
        }
      }
    }
  }
  .line {
    width: 100%;
    height: 0.4rem;
    padding-left: 0.14rem;
    border-left: 0.14rem solid #1883fe;
    margin-top: 0.2rem;
  }
  .foot {
    width: 100%;
    min-height: 6rem;
    background-color: #fff;
    border-radius: 0.14rem;
    margin-top: 0.3rem;
    padding: 0 0.2rem;
    padding-bottom: 10px;
    margin-bottom: 10px;
    > div:first-child {
      > div:last-child {
        max-width: 3rem;
        height: 0.6rem;
        margin-top: 0.15rem;
        line-height: 0.6rem;
        // text-align: center;
        // color: #fff;
        // font-size: 0.26rem;
        border-radius: 0.1rem;
        // background-color: #fda143;
      }
    }
    > div:last-child {
      border: none;
    }
    .item {
      display: flex;
      min-height: 0.9rem;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      display: flex;
      align-items: center;
      > div:first-child {
        min-width: 2rem;
      }
      > div:last-child {
        width: calc(100% - 2rem);
        color: #999;
      }
    }
    .item-content {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 2rem;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        min-height: 1rem;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: none;
        }
      }
      .desc-text {
        padding: 0.1rem;
      }
    }
    .item-content-m {
      width: 100%;
      > div:first-child {
        width: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        height: 1.4rem;
        color: #999;
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: 1px solid rgba(112, 112, 112, 0.1);
        }
      }
    }
  }
  .btns {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    color: #fff;
    text-align: center;
    font-size: 0.32rem;
    display: flex;
    > div {
      flex: 1;
      height: 100%;
    }
    .v1 {
      background-image: linear-gradient(to right, #fc9227, #febe76);
    }
    .v2 {
      background-image: linear-gradient(to right, #277cfc, #4dacff);
    }
  }
}
</style>